export const roles = {
  superAdmin: "Super Admin",
  hospitalAdmin: "Hospital Admin",
  reportingHospitalAdmin: "Reporting Hospital Admin",
  centerAdmin: "Center Admin",
  doctor: "Doctor",
  technician: "Technician",
  supervisor: "Supervisor",
};
